module.exports = __webpack_public_path__ + "static/media/contact.8c5fd962.png";